import { Injectable } from '@angular/core';
import { State, Store } from '@ngxs/store';
import { AnyBuildId } from '@portal-core/builds/constants/any-build-id.constant';
import { LatestBuildId } from '@portal-core/builds/constants/latest-build-id.constant';
import { Build } from '@portal-core/builds/models/build.model';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';

@CollectionStateSelectors({
  stateType: BuildsState
})
@State<BuildsState>({
  name: BuildsState.source,
})
@Injectable()
export class BuildsState extends CollectionStateBase {
  static source: string = 'Builds';

  static readonly defaultItems: Partial<Build>[] = [{
    Id: AnyBuildId
  }, {
    Id: LatestBuildId
  }];

  getDefaultItems(): Partial<Build>[] {
    return BuildsState.defaultItems;
  }

  getSource(): string {
    return BuildsState.source;
  }
}

@Injectable({
  providedIn: 'root'
})
export class BuildsDataService extends CollectionDataServiceBase<Build> {
  constructor(protected store: Store) {
    super(store, BuildsState);
  }
}
